import React from 'react';

import AssuranceElement from '@components/container/assurance-element';
import { useGetResources } from '@hooks/useGetResources';
import { type CategoryCard, PageRoutes, QueryStrings } from '@src/types/types';
import { useAppDispatch } from '@store';
import { getDefaultVerktoyFilters, setVerktoyFilters } from '@store/verktoy/slice/verktoySlice';
import { getCategoryCards } from '@utils/category-utils';
import { useNavigate } from 'react-router';

import type { FagomradeType } from '@src/types/minhelseentities';

import Button from '@helsenorge/designsystem-react/components/Button';
import ElementHeader from '@helsenorge/designsystem-react/components/ElementHeader';
import Icon from '@helsenorge/designsystem-react/components/Icon';
import ArrowRight from '@helsenorge/designsystem-react/components/Icons/ArrowRight';
import LinkList from '@helsenorge/designsystem-react/components/LinkList';
import Title from '@helsenorge/designsystem-react/components/Title';

import styles from './styles/categories.module.scss';

export const Categories = (): React.JSX.Element => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const resources = useGetResources();
  const categoryCards: CategoryCard[] = getCategoryCards(resources);

  const toAlleVerktoyLinkClicked = (): void => {
    const verktoyFilters = getDefaultVerktoyFilters();
    dispatch(setVerktoyFilters({ verktoyFilters }));
    navigate(PageRoutes.finnVerktoy);
  };

  const handleCategoryClick = (e: React.MouseEvent, category: FagomradeType): void => {
    e.preventDefault();
    navigate(`${PageRoutes.finnVerktoy}${QueryStrings.fagomrade}${category}`);
  };

  return (
    <div className={styles.sectionMargin}>
      <Title appearance="title2" htmlMarkup="h2">
        {resources?.finnVerktoy_header}
      </Title>
      <AssuranceElement extraClass={`${styles.elementMarginTop} ${styles.elementMarginBottom}`} />
      <LinkList chevron color="neutral" size="medium" variant="fill">
        {categoryCards?.map(card => (
          <LinkList.Link
            href={`${PageRoutes.finnVerktoy}${QueryStrings.fagomrade}${card.category}`}
            onClick={e => handleCategoryClick(e, card.category)}
            key={card.category}
            icon={<Icon svgIcon={card.icon} />}
          >
            <ElementHeader titleHtmlMarkup="span">
              <React.Fragment key={card.category + 'title'}>
                <span className={styles.categoryTitle}>{card.title}</span>
              </React.Fragment>
            </ElementHeader>
          </LinkList.Link>
        ))}
      </LinkList>
      <Button
        aria-roledescription={resources?.roleDescription_link}
        variant="borderless"
        className={styles.seeMoreButton}
        onClick={toAlleVerktoyLinkClicked}
      >
        {resources?.entryPage_alleVerktoy_link}
        <Icon svgIcon={ArrowRight} />
      </Button>
    </div>
  );
};
